import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './SelectOptionTags.module.scss';
import { getOptimalTextColor } from '../../../../../utils/colorHelper';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { ENTER_KEY_CODE, SPACE_KEY_CODE } from '../../../../../constants/common';

const TRANSLATE_OFFSET = 16;
const MENU_OFFSET = 32;

const SelectOptionTags = ({ inputRef, tags, search, onSelect, style, showEmptyMessage = true }) => {
  const [transform, setTransform] = useState('');
  const [selectFirstTrigger, setSelectFirstTrigger] = useState(false);
  const menuRef = useRef(null);

  const filteredTags = useMemo(() => {
    if (search?.length) {
      return tags.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
    }
    return tags;
  }, [tags, search]);

  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyPress = e => {
      switch (e.keyCode) {
        case ENTER_KEY_CODE:
        case SPACE_KEY_CODE:
          e.stopPropagation();
          setSelectFirstTrigger(true);
        default:
          break;
      }
    };

    inputRef?.current && inputRef.current.addEventListener('keydown', handleKeyPress);

    return () => inputRef?.current && inputRef.current.removeEventListener('keydown', handleKeyPress);
  }, [inputRef]);

  useEffect(() => {
    if (inputRef?.current && menuRef?.current) {
      let transform = `translateY(${inputRef?.current.offsetHeight + TRANSLATE_OFFSET}px)`;
      if (inputRef?.current) {
        const { top } = inputRef?.current?.getBoundingClientRect();
        if (top + menuRef.current.offsetHeight + TRANSLATE_OFFSET + MENU_OFFSET > window.innerHeight) {
          transform = `translateY(calc(-100% - ${TRANSLATE_OFFSET}px))`;
        }
      }
      setTransform(transform);
    }
  }, [menuRef?.current]);

  useEffect(() => {
    if (selectFirstTrigger) {
      filteredTags.length && onSelect(filteredTags[0].id);
      setSelectFirstTrigger(false);
    }
  }, [selectFirstTrigger]);

  if (!showEmptyMessage && !filteredTags.length) {
    return null;
  }

  return (
    <ul className={styles.optionsList} style={{ ...style, transform }} ref={menuRef}>
      {filteredTags.length ? (
        filteredTags.map(tag => (
          <li
            key={tag.id}
            className={cx(styles.optionItem, { [styles.outline]: tag.color === '#ffffff' })}
            style={{ backgroundColor: tag.color, color: getOptimalTextColor(tag.color) }}
            onClick={() => onSelect(tag.id)}
          >
            <span className={styles.tagName}>#{tag.name}</span>
          </li>
        ))
      ) : (
        <span className={styles.noOptions}>
          {t('dashboard.searching.no_matches')} ‘{search}’
        </span>
      )}
    </ul>
  );
};

export default SelectOptionTags;
